import { useState } from "react";
import GalleryManager from "../../components/admin/GalleryManager";
import EventsManager from "../../components/admin/EventsManager";
import OfficeHoldersManager from "../../components/admin/OfficeHoldersManager";

const TABS = [
  { id: "gallery", titleHindi: "गैलरी", titleEnglish: "Gallery" },
  { id: "events", titleHindi: "आयोजन", titleEnglish: "Events" },
  { id: "office", titleHindi: "पदाधिकारी", titleEnglish: "Office Bearers" },
];

const AdminDashboardPage = () => {
  const [activeTab, setActiveTab] = useState("gallery");

  return (
    <section className="admin-dashboard">
      <header>
        <h2>प्रशासनिक नियंत्रण</h2>
        <span className="caption">Administrative Console</span>
      </header>

      <div className="admin-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={activeTab === tab.id ? "active" : ""}
          >
            {tab.titleHindi}
            <span className="caption">{tab.titleEnglish}</span>
          </button>
        ))}
      </div>

      <div className="admin-tab-content">
        {activeTab === "gallery" && <GalleryManager />}
        {activeTab === "events" && <EventsManager />}
        {activeTab === "office" && <OfficeHoldersManager />}
      </div>
    </section>
  );
};

export default AdminDashboardPage;
